import { InfoIcon } from "lucide-react"

import { Alert, AlertDescription } from "@/components/ui/alert"
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip"

const NoTutorSelectedNotification = ({ openModal, lessonName }) => (
  <Alert
    variant="info"
    className="flex items-center gap-2 py-2 cursor-pointer border-dashed"
    onClick={openModal}
  >
    <Tooltip>
      <TooltipTrigger asChild>
        <InfoIcon className="h-5 w-5 text-blue-800 cursor-pointer" />
      </TooltipTrigger>
      <TooltipContent>
        <p className="max-w-xs">
          A tutor is an AI chatbot that helps the student with their work as they go along the pathway.
          Selecting a tutor is optional. If not selected, the student will proceed without AI assistance.
        </p>
      </TooltipContent>
    </Tooltip>
    <AlertDescription className="flex flex-wrap items-baseline gap-x-1 py-2">
      <span className="font-medium text-blue-600 hover:text-blue-800">
        Select a tutor
      </span>
      <span>for {lessonName}</span>
    </AlertDescription>
  </Alert>
)

export default NoTutorSelectedNotification
